module.exports = __webpack_public_path__ + "static/media/provider.bdca261b.png";